import {ai} from '@wix/document-services-implementation'
import type {PublicMethodUtils} from '@wix/document-services-types'

export default function (publicMethodUtils: PublicMethodUtils) {
    const {
        extensionPublicAPI: {getter, dataManipulation},
        defineAction,
        defineDataManipulationAction
    } = publicMethodUtils

    return {
        methods: {
            ai: {
                images: {
                    generateSimilarImages: defineDataManipulationAction(ai.onGenerateSimilarImagesSuccess, {
                        asyncPreDataManipulation: ai.generateSimilarImages,
                        isAsyncOperation: true
                    }),
                    matchImagesToPage: defineDataManipulationAction(ai.onMatchImagesToPageSuccess, {
                        asyncPreDataManipulation: ai.matchImagesToPage,
                        isAsyncOperation: true
                    }),
                    fitImagesToFrame: defineDataManipulationAction(ai.onFitImagesToFrameSuccess, {
                        asyncPreDataManipulation: ai.fitImagesToFrame,
                        isAsyncOperation: true
                    }),
                    removeImagesBackground: defineDataManipulationAction(ai.onRemoveImagesBackgroundSuccess, {
                        asyncPreDataManipulation: ai.removeImagesBackground,
                        isAsyncOperation: true
                    }),
                    editImages: defineDataManipulationAction(ai.onEditImagesSuccess, {
                        asyncPreDataManipulation: ai.editImages,
                        isAsyncOperation: true
                    }),
                    upscaleImages: defineDataManipulationAction(ai.onUpscaleImagesSuccess, {
                        asyncPreDataManipulation: ai.upscaleImages,
                        isAsyncOperation: true
                    })
                },
                content: {
                    updatePageContent: defineDataManipulationAction(ai.applyOutline, {
                        asyncPreDataManipulation: ai.getSuggestedOutline,
                        isAsyncOperation: true
                    }),
                    updateComponentBuilderContent: defineDataManipulationAction(ai.applyBuilderInjection, {
                        asyncPreDataManipulation: ai.getComponentInjectionForBuilder,
                        isAsyncOperation: true
                    }),
                    updateComponentBuilderImage: defineDataManipulationAction(ai.getComponentInjectionForBuilderImage),
                    updateComponentBuilderImageSG: defineDataManipulationAction(ai.applyBuilderImageInjectionSG, {
                        asyncPreDataManipulation: ai.getComponentInjectionForBuilderImageSG,
                        isAsyncOperation: true
                    }),
                    updateSiteContent: defineDataManipulationAction(ai.applyOutlines, {
                        asyncPreDataManipulation: ai.getSuggestedSiteOutlines,
                        isAsyncOperation: true
                    }),
                    generatePageLinks: defineDataManipulationAction(ai.generateLinksForOutline, {
                        asyncPreDataManipulation: ai.getPageLinksOutline,
                        isAsyncOperation: true
                    }),
                    generatePagesLinks: defineDataManipulationAction(ai.generatesLinksForOutline, {
                        asyncPreDataManipulation: ai.getPagesLinksOutline,
                        isAsyncOperation: true
                    }),
                    getContentByStructure: defineAction(ai.getSuggestedOutlineByStructure),
                    getContentByPageStructure: defineDataManipulationAction(ai.applyOutlineToPageStructure, {
                        asyncPreDataManipulation: ai.getSuggestedOutlineByPageStructure,
                        isAsyncOperation: true
                    }),
                    getContentByStructures: defineAction(ai.getSuggestedOutlineByStructures),
                    updateContentByPageStructure: defineDataManipulationAction(ai.applyOutlineToPage, {
                        asyncPreDataManipulation: ai.getSuggestedOutlineByPageStructure,
                        isAsyncOperation: true
                    }),
                    getPageOutline: getter('ai.content.getPageOutline'),
                    applyOutline: dataManipulation('ai.content.applyOutline'),
                    uploadAndInjectImages: defineDataManipulationAction(() => {}, {
                        asyncPreDataManipulation: ai.uploadAndInjectImages,
                        isAsyncOperation: true
                    })
                }
            }
        },
        initMethod: ai.initAITools
    }
}
